import {createContext, ReactNode, useContext, useState} from "react";
import {TermsAndConditionsResponse} from "../@types/public/termsAndConditionsResources.ts";
import useAsyncEffect from "use-async-effect";
import {getTermsAndConditions} from "../api";
import i18n from "i18next";
import {languageToIso3} from "../helpers/language/languageHelper.ts";

interface DataContextType {
    isPaymentTermsOpen: boolean;
    isPrivacyPolicyOpen: boolean;
    setIsPaymentTermsOpen: (arg0: boolean) => void;
    setIsPrivacyPolicyOpen: (arg0: boolean) => void;
    termsAndConditions: TermsAndConditionsResponse|undefined;
    setTermsAndConditions: (arg0: TermsAndConditionsResponse) => void;
}

const Data = createContext<DataContextType>({
    isPaymentTermsOpen: false,
    isPrivacyPolicyOpen: false,
    setIsPaymentTermsOpen: () => {},
    setIsPrivacyPolicyOpen: () => {},
    termsAndConditions: undefined,
    setTermsAndConditions: () => {},
});

const LegalTextsContext = ({ children }: { children: ReactNode }) => {
    const [isPaymentTermsOpen, setIsPaymentTermsOpen] = useState<boolean>(false);
    const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState<boolean>(false);
    const [termsAndConditions, setTermsAndConditions] = useState<TermsAndConditionsResponse>();

    useAsyncEffect(async () => {
        const {data} = await getTermsAndConditions(languageToIso3(i18n.language));

        setTermsAndConditions(data);
    }, []);

    return (
        <Data.Provider value={{
            isPaymentTermsOpen,
            isPrivacyPolicyOpen,
            setIsPaymentTermsOpen,
            setIsPrivacyPolicyOpen,
            termsAndConditions,
            setTermsAndConditions,
        }}>
            {children}
        </Data.Provider>
    );
};

export default LegalTextsContext;

export const LegalTextsState = () => {
    return useContext(Data);
};
